type Card = { type: 'News' | 'Blog' | 'Case Study'; date: string; title: string; image: string; logo?: string };

const featureCards: Card[] = [
  { type: 'News', date: 'Nov 01, 2021', title: "Website launched for India’s leading glass manufacturer", image: 'https://www.stercodigitex.com/siteassets/images/ais_window.webp', logo: 'https://www.stercodigitex.com/siteassets/images/ais_logo.webp' },
  { type: 'Case Study', date: 'Jan 21, 2020', title: 'New Website launched for India’s number 1 biscuit brand', image: 'https://www.stercodigitex.com/siteassets/images/news5.webp', logo: 'https://www.stercodigitex.com/siteassets/images/parle.svg' },
];

const sideCards: Card[] = [
  { type: 'Blog', date: 'July 08, 2022', title: '6 Small but Important Things to Observe in Web Design', image: 'https://www.stercodigitex.com/siteassets/images/right_image.webp' },
  { type: 'News', date: 'May 11, 2022', title: 'New Website launched for India’s largest automotive glass repair and replacement company.', image: 'https://www.stercodigitex.com/siteassets/images/ais_wind.webp', logo: 'https://www.stercodigitex.com/siteassets/images/ais_wind_logo.webp' },
];

export default function BlogNews() {
  return (
    <section className="bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-extrabold text-blue-900">From Our Diary</h2>
          <p className="text-gray-600 mt-2">We work hard to craft the best digital strategies and solutions for our business partners, and share what we learn with our community.</p>
        </div>

        {/* Desktop layout */}
        <div className="hidden md:grid grid-cols-12 gap-6 items-start">
          {/* Left feature card */}
          <div className="col-span-6">
            <div className="bg-white rounded-xl shadow overflow-hidden">
              <img src={featureCards[0].image} alt={featureCards[0].title} className="w-full h-80 object-cover" loading="lazy" />
              <div className="p-5">
                <div className="text-sm font-semibold text-blue-700">{featureCards[0].type}</div>
                <div className="text-gray-800 font-bold mt-2">{featureCards[0].date}</div>
                <p className="text-gray-700 mt-1">{featureCards[0].title}</p>
              </div>
            </div>
          </div>

          {/* Right stacked cards */}
          <div className="col-span-6 space-y-6">
            <div className="bg-white rounded-xl shadow overflow-hidden">
              <div className="p-5">
                <div className="text-sm font-semibold text-blue-700">{sideCards[0].type}</div>
                <div className="text-gray-800 font-bold mt-2">{sideCards[0].date}</div>
                <p className="text-gray-700 mt-1">{sideCards[0].title}</p>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow overflow-hidden">
              <img src={sideCards[1].image} alt={sideCards[1].title} className="w-full h-44 object-cover" loading="lazy" />
              <div className="p-5">
                <div className="text-sm font-semibold text-blue-700">{sideCards[1].type}</div>
                <div className="text-gray-800 font-bold mt-2">{sideCards[1].date}</div>
                <p className="text-gray-700 mt-1">{sideCards[1].title}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile stacked cards */}
        <div className="md:hidden space-y-6">
          {[...featureCards, ...sideCards].map((card) => (
            <div key={card.title} className="bg-white rounded-xl shadow overflow-hidden">
              {card.image && (
                <img src={card.image} alt={card.title} className="w-full h-56 object-cover" loading="lazy" />
              )}
              <div className="p-5">
                <div className="text-sm font-semibold text-blue-700">{card.type}</div>
                <div className="text-gray-800 font-bold mt-2">{card.date}</div>
                <p className="text-gray-700 mt-1">{card.title}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center gap-4 mt-10">
          <a href="#news" className="inline-block bg-blue-700 text-white px-6 py-2 rounded shadow hover:bg-blue-800 transition">View News</a>
          <a href="#blog" className="inline-block bg-blue-700 text-white px-6 py-2 rounded shadow hover:bg-blue-800 transition">View Blog</a>
        </div>
      </div>
    </section>
  );
}
